import React, { useState } from 'react';
import './WaitlistForm.css';

function WaitlistForm({ onSubmit }) {
  const [email, setEmail] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    if (email && email.includes('@')) {
      onSubmit(email);
    }
  };

  return (
    <main className="waitlist-main">
      <div className="waitlist-container">
        <div className="waitlist-content">
          <div className="badge">GET STARTED</div>
          <h1 className="main-title">
            MASTER DSA<br />
            WITH <span className="highlight">CODEFOX</span>
          </h1>
          <p className="subtitle">
            Join learners leveling up with gamified, mobile-first DSA lessons.<br />
            Build daily habits, boost your skills, and prep for top tech interviews.
          </p>
          
          <form className="waitlist-form" onSubmit={handleSubmit}>
            <div className="form-group">
              <input
                type="email"
                className="email-input"
                placeholder="Enter your email address"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
              <button type="submit" className="submit-btn">
                Join Waitlist
              </button>
            </div>
          </form>
        </div>

        <div className="mascot-container">
          <div className="glow-effect"></div>
          <img src="/images/mascot.png" alt="CodeFox Mascot" className="main-mascot" />
        </div>
      </div>

      <div className="decorative-elements">
        <div className="circle circle-1"></div>
        <div className="circle circle-2"></div>
        <div className="circle circle-3"></div>
      </div>
    </main>
  );
}

export default WaitlistForm;

